import { Component } from "@angular/core";

@Component({
    selector: 'dialog-content-terms-dialog',
    templateUrl: 'dialog-content-terms-dialog.html',
  })
  export class DialogContentTermsDialog {}